module.exports = __webpack_public_path__ + "img/Shuoyao Wang.cfa14b11.jpg";